import {Component, OnInit} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {MobileService} from "../../shared/services/mobile.service";

@Component({
    selector: 'app-dashboard-layout',
    templateUrl: './dashboard-layout.component.html',
    styleUrls: ['./dashboard-layout.component.scss'],
    standalone: false
})
export class DashboardLayoutComponent implements OnInit {
  layout: Observable<{toolbar: boolean, footer: boolean}> = new BehaviorSubject({toolbar: true, footer: true});

  constructor(
    public mobileService: MobileService
  ) { }

  ngOnInit(): void {
  }

}
